/* Armar una frase sin conexión: eliges la plantilla, la palabra y sale en japonés con su pronunciación. */
import { useState } from 'react';
import { guardarFrase } from '../datos/apuntes.ts';
import { CANTIDADES, PLANTILLAS, VOCABULARIO, type Grupo, type Palabra, type Plantilla } from '../datos/constructor.ts';
import { leer } from '../datos/frases.ts';
import type { Frase } from '../datos/tipos.ts';

export function Constructor({ onGrande }: { onGrande: (f: Frase) => void }) {
  const [plantilla, setPlantilla] = useState<Plantilla>(PLANTILLAS[0]);
  const [grupo, setGrupo] = useState<Grupo>(PLANTILLAS[0].grupos[0]);
  const [palabra, setPalabra] = useState<Palabra | null>(null);
  const [cantidad, setCantidad] = useState(CANTIDADES[1]);
  const [guardada, setGuardada] = useState(false);

  const elegir = (t: Plantilla) => { setPlantilla(t); if (t.grupos.length) setGrupo(t.grupos[0]); setPalabra(null); setGuardada(false); };
  const lista = plantilla.grupos.length ? VOCABULARIO[grupo].palabras : [];
  const listo = plantilla.grupos.length === 0 || palabra !== null;
  const salida = listo ? plantilla.armar(palabra, plantilla.cantidad ? cantidad : null) : null;
  const frase: Frase | null = salida && { situacion: 'Mis frases', es: salida.es, ja: salida.ja, romaji: salida.ro };

  return (
    <details className="plegable constructor">
      <summary>Armar una frase · sin conexión</summary>
      <div>
        <p className="texto" style={{ fontSize: '.85rem' }}>Elige qué quieres decir y la palabra: el japonés sale sin red ni traducción automática.</p>
        <div className="filtros constructor__plantillas" role="group" aria-label="Qué quieres decir">
          {PLANTILLAS.map(t => <button key={t.id} type="button" aria-pressed={plantilla.id === t.id} onClick={() => elegir(t)}>{t.titulo}</button>)}
        </div>
        {plantilla.grupos.length > 1 && (
          <div className="filtros" role="group" aria-label="Tipo de palabra">
            {plantilla.grupos.map(g => <button key={g} type="button" aria-pressed={grupo === g} onClick={() => { setGrupo(g); setPalabra(null); }}>{VOCABULARIO[g].titulo}</button>)}
          </div>
        )}
        {plantilla.cantidad && (
          <div className="filtros" role="group" aria-label="Cuántos">
            {CANTIDADES.map(c => <button key={c.n} type="button" aria-pressed={cantidad.n === c.n} onClick={() => setCantidad(c)}>{c.n}</button>)}
          </div>
        )}
        {lista.length > 0 && (
          <div className="constructor__palabras" role="group" aria-label="Palabra">
            {lista.map(w => <button key={w.ja + w.es} type="button" aria-pressed={palabra === w} onClick={() => { setPalabra(w); setGuardada(false); }}>{w.es}</button>)}
          </div>
        )}
        {frase && salida && (
          <div className="traduccion" role="status">
            <span className="frase__es traduccion__es">{salida.es}</span>
            <span className="frase__ja" lang="ja">{salida.ja}</span>
            <span className="frase__romaji">{salida.ro}</span>
            <div className="traduccion__acciones">
              <button type="button" className="accion" onClick={() => leer(frase)}>🔊 Escuchar</button>
              <button type="button" className="accion" onClick={() => onGrande(frase)}>Ver en grande</button>
              <button type="button" className="accion" disabled={guardada} onClick={() => { guardarFrase({ es: frase.es, ja: frase.ja, romaji: frase.romaji }); setGuardada(true); }}>{guardada ? '✓ Guardada' : '＋ Guardar'}</button>
            </div>
          </div>
        )}
      </div>
    </details>
  );
}
